import script from "./activate.vue?vue&type=script&setup=true&lang=js"
export * from "./activate.vue?vue&type=script&setup=true&lang=js"

import "./activate.vue?vue&type=style&index=0&id=296bf903&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296bf903"]])

export default __exports__